import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseUtils, FuseAnimate} from '@fuse';
import {bindActionCreators} from 'redux';
import ReduxTrialVip from "../../../../store/actionreducers/trialVip";
import ReactTable from "react-table";
import classNames from 'classnames';
import {
    Avatar,
    Icon,
    IconButton,
    Typography
} from '@material-ui/core';
import {constDataDialogs} from "../../../../constants";
import ReduxGlobal from "../../../../store/actionreducers/globalView";

const styles = theme => ({
    mailList: {
        padding: 0
    },
    mailItem: {},
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {}

});

class TrialVipList extends Component {

    state = {
        selectedContactsMenu: null
    };

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    render() {

        const {
            classes, searchText, openDataDialog, openAlertDialog, disableTrialVip,
            getTrialVip, trialVips, getTrialVips, openLoadingMask, closeLoadingMask,
        } = this.props;

        const data = this.getFilteredArray(trialVips, searchText);

        if (!data && data.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有任何測試會員
                    </Typography>
                </div>
            );
        }

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何測試會員"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    className={classNames(classes.root, "-striped -highlight")}
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: async (e, handleOriginal) => {
                                if (rowInfo) {
                                    const trialVipId = rowInfo.original.id;
                                    await getTrialVip(trialVipId);
                                    openDataDialog({type: 'edit', name: constDataDialogs.name.trialVipDialog}); // 打開 trialVipDialog
                                }
                            }
                        }
                    }}
                    data={
                        data.sort(function (preVip, currVip) {
                            return currVip.id - preVip.id;
                        })
                    }
                    columns={[
                        {
                            Header: "",
                            width: 64,
                            accessor: "user.avatar.url",
                            Cell: row => {
                                return (<Avatar className="mr-8" alt={row.original.user.name} src={row.value}/>);
                            },
                            className: "justify-center",
                            sortable: false
                        },
                        {
                            Header: "姓名",
                            accessor: "user.name",
                            filterable: true,
                            className: "font-bold"
                        },
                        {
                            Header: "Email",
                            accessor: "user.email",
                            filterable: true
                        },
                        {
                            Header: "密碼",
                            accessor: "trial_vip_password",
                            filterable: true,
                            className: "font-bold"
                        },
                        {
                            Header: "性別",
                            accessor: "user.sex",
                            filterable: true,
                            className: "font-bold"
                        },
                        {
                            Header: "生日",
                            accessor: "user.birthday",
                            filterable: true,
                            type: "date",
                        },
                        {
                            Header: "手機號碼",
                            accessor: "user.cell_phone_no",
                            filterable: true
                        },
                        {
                            Header: "狀態",
                            accessor: "status.name",
                            filterable: true
                        },
                        {
                            Header: "停用",
                            width: 64,
                            Cell: row => {
                                if (row.original.status.label !== 'enable') return <div className="flex items-center"/>;
                                else return (
                                    <div className="flex items-center">
                                        <IconButton
                                            onClick={(ev) => {

                                                ev.stopPropagation();
                                                const vip = row.original;
                                                const alertDialogInfo = {
                                                    title: '停用帳號',
                                                    message: `請問您要停用帳號(${vip.user.name})嗎?`,
                                                    yesButton: {
                                                        label: '是',
                                                        onClick: async () => {
                                                            try {
                                                                openLoadingMask();
                                                                await disableTrialVip(vip.id);
                                                                await getTrialVips();
                                                                closeLoadingMask();
                                                            } catch (e) {
                                                                console.warn('you got an error = ', e);
                                                            }
                                                        },
                                                    },
                                                    noButton: {label: '否'}
                                                };

                                                openAlertDialog(alertDialogInfo); // disable VIP
                                            }}
                                        >
                                            <Icon>not_interested</Icon>
                                        </IconButton>
                                    </div>
                                )
                            }
                        }
                    ]}
                    defaultPageSize={10}
                />
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        getTrialVips: ReduxTrialVip.ActionCreator.getTrialVips,
        getTrialVip: ReduxTrialVip.ActionCreator.getTrialVip,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        disableTrialVip: ReduxTrialVip.ActionCreator.disableTrialVip,
    }, dispatch);
}

function mapStateToProps({contactsApp, trialVip: {trialVips}, global: {searchText}}) {
    return {
        contacts: contactsApp.contacts.entities,
        selectedContactIds: contactsApp.contacts.selectedContactIds,
        trialVips,
        searchText,
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(TrialVipList)));



// WEBPACK FOOTER //
// ./src/main/content/sales/trial_vip/TrialVipList.js